"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Reward_1 = __importDefault(require("../../../Icons/Notifications/Reward"));
var NotificationItem_1 = __importDefault(require("../../NotificationItem"));
var utils_1 = require("../../utils");
var NotificationItemNFTLink_1 = __importDefault(require("../../NotificationItemNFTLink"));
var config_1 = require("../../../../config");
var i18N = {
    en: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "This",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "is already in your backpack")); },
        title: 'New Item Received'
    },
    es: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "El item",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "ya esta disponible en tu backpack")); },
        title: 'Nuevo artículo recibido'
    },
    zh: {
        description: function (reward) { return (react_1.default.createElement(react_1.default.Fragment, null,
            "\u8FD9",
            react_1.default.createElement(NotificationItemNFTLink_1.default, { rarity: reward.tokenRarity, name: reward.tokenName, link: config_1.config.get('EXPLORER_URL') }),
            "\u5DF2\u7ECF\u5728\u60A8\u7684\u80CC\u5305\u91CC")); },
        title: '收到的新项目'
    }
};
/**
 * @deprecated Should start using the same component migrated to UI2.
 */
function RewardAssignedNotification(_a) {
    var notification = _a.notification, locale = _a.locale;
    return (react_1.default.createElement(NotificationItem_1.default, { image: {
            image: notification.metadata.tokenImage,
            backgroundColor: (0, utils_1.getBGColorByRarity)(notification.metadata.tokenRarity),
            icon: react_1.default.createElement(Reward_1.default, null)
        }, timestamp: notification.timestamp, isNew: !notification.read, locale: locale },
        react_1.default.createElement("p", { className: "dcl notification-item__content-title" }, i18N[locale].title),
        react_1.default.createElement("p", { className: "dcl notification-item__content-description" }, i18N[locale].description(notification.metadata))));
}
exports.default = RewardAssignedNotification;
